import { DatePicker } from "@mui/x-date-pickers";
import { prettify, renderEUDate } from "../../../utils/utils";
import {
  EditableDateInput,
  EditableInputDisplay,
} from "../../EditableComponents";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { services } from "../../ServiceComponents";

const getColumns = (setEditMode, setParentValue) => {
  return [
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      Cell: ({ cell, row }) => prettify(row.original.service),
      header: "Servizio",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      header: "Data di Inizio",
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"start_date"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.start_date}
          inputMode={"date"}
          setParentValue={setParentValue}
        />
      ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      header: "Data di Fine",
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"end_date"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.end_date}
          inputMode={"date"}
          setParentValue={setParentValue}
        />
      ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 50,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"note1"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.note1}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Nota 1",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 50,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"note2"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.note2}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Nota 2",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      enableEditing: false,
      size: 150,
      accessorFn: (row) => prettify(row.delivery),
      header: "Ritiro Dispositivi",
    },
    {
      size: 5,
      enableEditing: false,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"is_active"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.is_active}
          inputMode={"bool"}
          setParentValue={setParentValue}
        />
      ),
      muiTableHeadCellFilterTextFieldProps: {
        placeholder: "Attivo/inattivo",
      },
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Attivo",
    },
  ];
};

export default getColumns;
